import * as React from 'react';
import { Tooltip as BaseTooltip } from '@base-ui-components/react/tooltip';
import { cn } from '@/lib/utils';

const TooltipProvider = BaseTooltip.Provider;
const Tooltip = BaseTooltip.Root;
const TooltipTrigger = BaseTooltip.Trigger;

const TooltipContent = React.forwardRef<
  React.ComponentRef<typeof BaseTooltip.Popup>,
  React.ComponentPropsWithoutRef<typeof BaseTooltip.Popup> & {
    sideOffset?: number;
    side?: React.ComponentPropsWithoutRef<typeof BaseTooltip.Positioner>['side'];
  }
>(({ className, sideOffset = 4, side, ...props }, ref) => (
  <BaseTooltip.Portal>
    <BaseTooltip.Positioner sideOffset={sideOffset} side={side} className="z-popover">
      <BaseTooltip.Popup
        ref={ref}
        // Base UI's popup carries no role; a tooltip is announced as one (and found as one).
        role="tooltip"
        className={cn(
          'max-w-xs overflow-hidden rounded-md bg-foreground px-3 py-1.5 text-[length:var(--t-th)] text-background transition-opacity duration-150 data-[ending-style]:opacity-0 data-[starting-style]:opacity-0',
          className,
        )}
        {...props}
      />
    </BaseTooltip.Positioner>
  </BaseTooltip.Portal>
));
TooltipContent.displayName = 'TooltipContent';

export { Tooltip, TooltipTrigger, TooltipContent, TooltipProvider };
